import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { contactInfo, personalInfo } from '../data/mock';
import { trackCtaClick } from '../utils/analytics';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleWhatsApp = () => {
    const message = encodeURIComponent(contactInfo.whatsappMessage);
    const whatsappUrl = `https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${message}`;
    trackCtaClick({ cta: 'whatsapp', location: 'hero', url: whatsappUrl });
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="hero" className="hero-section">
      <div className="container-custom">
        <div className="hero-content">
          <h1 className="hero-title">{personalInfo.name}</h1>
          <h2 className="hero-headline">{personalInfo.headline}</h2>
          <p className="hero-subheadline">{personalInfo.subheadline}</p>
          
          <div className="hero-badges">
            {personalInfo.badge && (
              <div className="hero-badge">
                {personalInfo.badge}
              </div>
            )}
            {personalInfo.badge2 && (
              <div className="hero-badge hero-badge-secondary">
                {personalInfo.badge2}
              </div>
            )}
          </div>
          
          <div className="hero-cta">
            <button onClick={handleWhatsApp} className="btn-primary">
              Falar no WhatsApp
              <ArrowRight size={20} />
            </button>
            <button onClick={() => scrollToSection('social')} className="btn-secondary">
              Ver conteúdos
            </button>
            <button onClick={() => scrollToSection('casos')} className="btn-tertiary">
              Ver casos
            </button>
          </div>
        </div>
      </div>
      
      <button onClick={() => scrollToSection('sobre')} className="scroll-indicator" aria-label="Rolar para baixo">
        <ChevronDown size={32} />
      </button>
    </section>
  );
};

export default Hero;
